var _excluded = ["slides", "ratio", "hasArrowsOnMobile"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment, useContext, useRef, useState } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import ResizeDetector from "../../../helpers/ResizeDetector";
import LinkAtm from "../../atoms/LinkAtm";
import TextAtm from "../../atoms/TextAtm";
import { defaultProps } from "./SliderTemplate.props";
import { ArrowButton, ArrowIcon, ArrowsContainer, MediaContainer, StyledCarousel, TextContainer, Wrapper } from "./SliderTemplate.styled";
function SliderTemplate(_ref) {
  var slides = _ref.slides,
    _ref$ratio = _ref.ratio,
    ratio = _ref$ratio === void 0 ? defaultProps.ratio : _ref$ratio,
    hasArrowsOnMobile = _ref.hasArrowsOnMobile,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var sliderRef = useRef(null);
  var imageRefs = useRef([]);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    biggestImageHeight = _useState2[0],
    setBiggestImageHeight = _useState2[1];
  var carouselSettings = {
    arrows: false,
    dots: true,
    centerMode: true,
    centerPadding: "0",
    wrapAround: true
  };
  var handleArrowLeftClick = function handleArrowLeftClick() {
    var _sliderRef$current;
    return (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.slickPrev();
  };
  var handleArrowRightClick = function handleArrowRightClick() {
    var _sliderRef$current2;
    return (_sliderRef$current2 = sliderRef.current) === null || _sliderRef$current2 === void 0 ? void 0 : _sliderRef$current2.slickNext();
  };
  var setBiggestImageHeightValue = function setBiggestImageHeightValue() {
    return setBiggestImageHeight(Math.max.apply(Math, _toConsumableArray(imageRefs.current.map(function (_ref2) {
      var clientHeight = _ref2.clientHeight;
      return clientHeight;
    }))));
  };
  return /*#__PURE__*/React.createElement(Wrapper, restProps, /*#__PURE__*/React.createElement(StyledCarousel, _extends({}, carouselSettings, {
    $onColor: onColor,
    ref: sliderRef
  }), slides.map(function (_ref3, index) {
    var image = _ref3.image,
      title = _ref3.title,
      text = _ref3.text,
      link = _ref3.link;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(ResizeDetector, {
        onChange: setBiggestImageHeightValue
      }, /*#__PURE__*/React.createElement(MediaContainer, {
        $ratio: ratio,
        ref: function ref(_ref4) {
          if (_ref4) {
            imageRefs.current[index] = _ref4;
          }
        }
      }, image)), title || text || link ? /*#__PURE__*/React.createElement(TextContainer, {
        $hasArrowsOnMobile: hasArrowsOnMobile
      }, title ? /*#__PURE__*/React.createElement(TextAtm, {
        typography: "big3"
      }, title) : null, text ? /*#__PURE__*/React.createElement(TextAtm, {
        typography: "medium1_s"
      }, text) : null, link ? /*#__PURE__*/React.createElement(LinkAtm, {
        to: link.to,
        href: link.href,
        title: link.title,
        openInNewTab: link.openInNewTab,
        scrollTo: link.scrollTo,
        onClick: link.onClick,
        typography: "small4"
      }, link.text) : null) : null)
    );
  })), /*#__PURE__*/React.createElement(ArrowsContainer, {
    $ratio: ratio,
    $biggestImageHeight: biggestImageHeight,
    $hasArrowsOnMobile: hasArrowsOnMobile
  }, /*#__PURE__*/React.createElement(ArrowButton, {
    onClick: handleArrowLeftClick,
    $direction: "left",
    $onColor: onColor
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    $onColor: onColor
  })), /*#__PURE__*/React.createElement(ArrowButton, {
    onClick: handleArrowRightClick,
    $direction: "right",
    $onColor: onColor
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    $onColor: onColor
  }))));
}
export default SliderTemplate;